import React from 'react';

const ProspectEmailFormat = ({ email, url, message, title }) => {
  // Placeholder function to create email content
  // Replace this with the actual method from 'create-email' to format your email
  const createEmailContent = (title, message, url) => {
    return `Subject: ${title}\n\n${message}\nSee more at: ${url}`;
  };

  const emailContent = createEmailContent(title, message, url);
  const encodedContent = encodeURIComponent(emailContent);
  const encodedSubject = encodeURIComponent(title);

  return (
    <div>
      <a href={`mailto:${email}?subject=${encodedSubject}&body=${encodedContent}`} target="_blank" rel="noopener noreferrer">
        Send Email
      </a>
    </div>
  );
};

export default ProspectEmailFormat;
